import { JetpacPayApi  } from 'api'
import { AxiosPromise } from 'axios'
import { GetRefundHistoryData } from 'types/api/v1/refund.type'


class RefundAPI {
  static getCustomerRefundHistory(
    {
      faberToken
    }: {
      faberToken: string
    },
    customerId: string | undefined,
    paymentIntent: string

  ): AxiosPromise<GetRefundHistoryData> {
    return JetpacPayApi.httpGet(
      `/ops/refund/history/${customerId}/${paymentIntent}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }
}

export default RefundAPI